import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row, Button, Form } from "react-bootstrap";
import Select from "react-select";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { useNavigate, useParams } from "react-router-dom";
import { formdeletefunder, formlistfunder, schformdetail, addFundersToForm } from "../../../../services/superadmin";
import { funderlist } from "../../../../services/master";

export const FormFunderList = () => {
    const { id } = useParams();
    const [filterProduct, setFilterProduct] = useState([]);
    const [fname, setFName] = useState("");
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [funderOptions, setFunderOptions] = useState([]);
    const [selectedFunders, setSelectedFunders] = useState([]);
    const [loading, setLoading] = useState(false);

    const sorting = useMemo(() => {
        return ['asc', 'desc',];
    }, []);

    const columnDefs = [
        {
            headerName: "Funder Name",
            field: "funder_name",
            width: 300,
            sortable: true,
            resizable: true,
            sorting: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Actions",
            field: "id",
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => deletectype(params)} title="Delete Funder"
                            className="btn-sm btn-danger"
                        >
                            <i className="fa fa-trash fa-lg"></i>
                        </a>
                    </div>

                );
            },
        },
    ];



    function deletectype(list) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                dotracking(
                    "delete icon in form funder list for " + list.data.funder_name + " (" + list.data.id + ") $$ " + trackobj.formfunderheading
                )
                formdeletefunder(list.data.id).then((response) => {
                    if (response.status === true) {
                        listall();
                        toast.success(response.message)
                    }
                })
            }
        });

    }

    useEffect(() => {
        schformdetail(id).then((res) => {
            if (res.status === true) {
                setFName(res.data.scholarship_form.form_name);
            }
        })
        listall();
    }, []);

    function listall() {
        setFilterProduct([]);
        formlistfunder(id).then((response) => {
            if (response.status === true) {
                setFilterProduct(response.data.funders)
            }
        })
    }

    function backlist() {
        dotracking("back button in form funder list for " + fname + " (" + id + ") $$ " + trackobj.schlistheading);
        navigate("/superadmin/scholarshipformlist")
    }

    function openAddFunderModal() {
        dotracking("add funder button in form funder list for " + fname + " (" + id + ") $$ " + trackobj.formfunderheading);
        setShowModal(true);
        loadFundersList();
    }

    function loadFundersList() {
        funderlist().then((response) => {
            if (response.status === true) {
                const options = response.data.funders_list.map((funder) => ({
                    value: funder.id,
                    label: funder.funder_name
                }));
                setFunderOptions(options);
            }
        });
    }

    function handleFunderChange(selected) {
        setSelectedFunders(selected || []);
    }

    function handleCloseModal() {
        setShowModal(false);
        setSelectedFunders([]);
    }

    function handleSaveFunders() {
        if (selectedFunders.length === 0) {
            toast.error("Please select at least one funder");
            return;
        }

        setLoading(true);
        const data = {
            form_details_id: id,
            funder_count: selectedFunders.length
        };

        selectedFunders.forEach((funder, index) => {
            data[`funder_id_${index + 1}`] = funder.value;
        });

        dotracking("save funders in add funder modal for " + fname + " (" + id + ") $$ " + trackobj.formfunderheading);

        addFundersToForm(data).then((response) => {
            setLoading(false);
            if (response.status === true) {
                toast.success(response.message);
                handleCloseModal();
                listall();
            } else {
                toast.error(response.message || "Failed to add funders");
            }
        }).catch(() => {
            setLoading(false);
            toast.error("An error occurred while adding funders");
        });
    }
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Form Funder Lists</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship Form</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Form Funder Lists
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <form className="card mt-0">

                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-7">
                                    <h3>{fname}</h3>
                                </div>
                                <div className="col-md-5">
                                    <div className="text-right">
                                        <a className="btn btn-gray me-2" onClick={backlist}>
                                            <i className="fe fe-corner-up-left"></i> Back
                                        </a>
                                        <a className="btn btn-success me-2" onClick={openAddFunderModal}>
                                            <i className="fa fa-plus"></i> Add Funder
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={sorting}
                                    suppressExcelExport={true}
                                    suppressDragLeaveHidesColumns={true}
                                    domLayout="autoWidth"
                                    onGridReady={(params) => {
                                        params.api.sizeColumnsToFit();
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Funders</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>
                                Select Funders <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                                isMulti
                                options={funderOptions}
                                value={selectedFunders}
                                onChange={handleFunderChange}
                                placeholder="Select funders..."
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleSaveFunders} disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>


    );
};
